// src/components/Footer.js
import React from "react";

function Footer() {
  return (
    <footer>
      {/* MAP & OTHER INFO */}
      <div id="location" className="map-container">
        <h2>Our Location</h2>
        <iframe
          title="Clipper Kings Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3171.8559902488763!2d-121.87616228436141!3d37.34098934601353!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fcbfdc6f881eb%3A0xd3a202c3e86cc3fb!2s964%20E%20Santa%20Clara%20St%2C%20San%20Jose%2C%20CA%2095116!5e0!3m2!1sen!2sus!4v1234567890000"
          width="100%"
          height="300"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>

      <div className="footer-info">
        <div className="footer-address">
          <h3>ADDRESS</h3>
          <p>964 E Santa Clara St, San Jose, CA 95116</p>
          <p>(408) 320-2753</p>
        </div>

        <div className="footer-hours">
          <h3>HOURS</h3>
          <p>9AM - 7PM, Monday - Sunday</p>
        </div>
      </div>

      {/* SOCIAL ICONS ROW */}
      <div className="footer-icons">
        <a
          href="https://instagram.com/evergreenbarberSHOP"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-instagram" />
        </a>
        <a
          href="https://www.youtube.com/channel/UCz2KL1BlMN8XWjJqCL1CZ_g"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-youtube" />
        </a>
        <a
          href="https://www.facebook.com/evergreenbarbershopsj/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-facebook-f" />
        </a>
        <a
          href="http://www.yelp.com/biz/evergreen-barbershop-san-jose"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-yelp" />
        </a>
      </div>

      <div className="footer-bottom">
        <p>
          &copy; 2024 Clipper Kings Barbershop | Built with <span role="img" aria-label="love">❤️</span> by{" "}
          <a href="https://5995studios.com" target="_blank" rel="noopener noreferrer">
            5995Studios
          </a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
